import { useParams } from "react-router-dom";
import { StateInfoList } from "./StateInfoList";

/** Shows the starting parameters in `Gbd`. Those are set in the URL. */
export function GbdStateInfo(): JSX.Element {
  const { variant, pages } = useParams();

  return (
    <StateInfoList
      rows={[
        ["variant", variant],
        ["pages", pages, "5"],
      ]}
    />
  );
}
